import { Col, Row } from "react-bootstrap";
import { IFindingAndRecommendationDetails } from "../../../api/IFindingAndRecommendation";
import EpaCard from "../../../leap-components/EpaCard";
import EpaField from "../../../leap-components/EpaField";
import EpaFieldHtml from "../../../leap-components/EpaFieldHtml";

interface RequestForInformationDetailsProps {
  findingAndRecommendation: IFindingAndRecommendationDetails;
}

const FindingAndRecommendationDetails = ({
  findingAndRecommendation,
}: RequestForInformationDetailsProps) => {
  const linkToSiteVisitDetails = `/licence-profile/${findingAndRecommendation.profileNo}/compliance/sitevisit/${findingAndRecommendation.regardingobjectid}`;
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Date Submitted by the EPA"}
            value={findingAndRecommendation.datesubmitted}
          />
          <EpaField
            label={"Subject"}
            value={findingAndRecommendation.subject}
          />
          <EpaField label={"Sender"} value={findingAndRecommendation.sender} />
          <EpaField
            label={"Category"}
            value={findingAndRecommendation.category}
          />
        </Col>
        <Col className="col-12 col-md-6">
          <EpaField
            label={"Licensee Response Due Date"}
            value={findingAndRecommendation.duedate}
          />
          <EpaField label={"Type"} value={findingAndRecommendation.type} />
          <EpaField
            label={"Recipient"}
            value={findingAndRecommendation.recipient}
          />
          <EpaField
            label={"Subcategory"}
            value={findingAndRecommendation.subcategory}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Observation (EPA Originated)"}
            value={findingAndRecommendation.observation}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
      <Row>
        <Col className="col-12">
          <EpaFieldHtml
            label={"Action (EPA Originated)"}
            value={findingAndRecommendation.description}
            labelClassName={"col-12 col-md-12"}
            valueClassName={"col-12 col-md-12"}
          />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return (
    <EpaCard
      title={"Finding / Recommendation Details"}
      content={bodyElements}
    />
  );
};

export default FindingAndRecommendationDetails;
